import { useCallback, useRef, useState } from 'react';
import Modal from 'src/Utils/CssModules/modal.module.css';
import './PopupDialog.css'
import Button from '../Button/Button';
export interface IPopupDialogParams{
    title: string
    children: React.ReactNode,
    submitButtonText: string;
    onClose: () => void;
}
const PopupInfoDialog:React.FC<IPopupDialogParams> = ({title, children, submitButtonText, onClose}) => {
    const [display, setdisplay] = useState('block');
    const wrapperRef = useRef<HTMLDivElement>(null);
    const submit = useCallback(() => {
        setdisplay('none');
        onClose();
    }, [onClose]);
    return(
        <>
          <div className='row '>
            <div id="myModal" className={`${Modal.modal}`} style={{ display: display, zIndex: 1001 }}>
                <div className={`${Modal.content} smallcontent`} ref={wrapperRef}>
                    <div className={`${Modal.header} pb-2`} style={{ textAlign: 'center' }}>
                        <div style={{fontWeight:'600', fontSize: '24px', paddingRight: '26px'}}>{title}</div>
                    </div>
                
                    <div className={Modal.body} style={{padding:'1px 30px 0px 30px'}}>
                        {children}
                    </div>
                
                    <div className={Modal.footer} style={{padding:'3px 33px 17px 149px'}}>
                        <div className="row" >
                            <div className='col-auto me-auto'>
                                <Button
                                  testId='ok'
                                  onClick={() => { submit() }}
                                  text={submitButtonText}
                                  width='141px'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         </div>
        </>
    )
}
export default PopupInfoDialog